<template>
    <div>
        <store-cover-image></store-cover-image>
        <category-nav></category-nav>
        <product-list :products="products" :loading="loading"></product-list>
    </div>
</template>

<script>
import categoryNav from '@/components/common/category-nav';
import productList from '@/components/common/product-list';
import storeCoverImage from '@/components/common/store-cover-image';
import { mapState } from 'vuex';

export default {
    name: 'ProductList',
    components: {
        categoryNav,
        productList,
        storeCoverImage,
    },
    props: {},
    data() {
        return {
            products: [],
            loading: false,
        };
    },
    computed: {
        ...mapState(['service', 'category']),
        imgHost() {
            return `${process.env.BASE_URL}static/images/`;
        },
        storeBackground() {
            return `${this.imgHost}products/${this.service.service_name}/${this.service.service_name}_bg.png`;
        },
        url_category_id() {
            return this.$route.params.category;
        },
    },
    watch: {
        url_category_id: {
            handler: function() {
                this.getProducts();
            },
        },
    },
    mounted() {
        this.$store.commit('clearProductCrumb');
        this.getProducts();
    },
    methods: {
        getProducts() {
            this.loading = true;
            this.$shopAPI
                .getItemList(this.$i18n.locale, this.service.service_group_code, this.category.no)
                .then(
                    (items) => {
                        this.products = items;
                    },
                    () => {
                        this.$router.push({
                            name: 'error',
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="less" scoped>
.store-container {
    align-items: center;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    .store-content {
        max-width: 1340px;
        overflow: hidden;
        padding: 0 30px 360px;
        width: 100%;
    }
}
@media (max-width: 768px) {
    .store-container .store-content {
        padding: 0 0 360px;
    }
}
</style>
